import request from '@/utils/request'; // 获取区域管理列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/building/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/building/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/building/info',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/building/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/building/update',
    method: 'post',
    data: data
  });
} // 导入数据

export function importBatch(data) {
  return request({
    url: '/pmsservice/api/building/importBatch',
    method: 'post',
    data: data
  });
}